// @flow
import {BaseRetryUtils} from "../../../infrastructure/utils/base-retry-utils";
import {singleton} from "../../../infrastructure/decorators/singleton";

/**
 * KinesisRetryUtils - Kinesis-specific retry utility
 *
 * Extends BaseRetryUtils with AWS Kinesis SDK v3 specific error codes
 * and backoff strategy optimized for AWS rate limiting behavior.
 */
@singleton
export class KinesisRetryUtils extends BaseRetryUtils {
  static injectables = [...BaseRetryUtils.injectables];

  // AWS Kinesis exponential backoff delays (5 retry attempts)
  // Optimized for AWS ProvisionedThroughputExceededException and throttling
  static BACKOFF_DELAYS = [1000, 5000, 30000, 120000, 300000]; // 1s, 5s, 30s, 2m, 5m

  // AWS SDK v3 error codes that should trigger a retry
  static RETRYABLE_ERROR_CODES = [
    'ProvisionedThroughputExceededException',
    'ServiceUnavailable',
    'InternalFailure',
    'InternalError',
    'ThrottlingException',
    'Throttling',
    'TooManyRequestsException',
    'RequestTimeout',
    'RequestTimeoutException',
    'ServiceUnavailableException',
    'SlowDown'
  ];

  // AWS SDK v3 non-retryable error codes - permanent failures
  static NON_RETRYABLE_ERROR_CODES = [
    'ValidationException',
    'InvalidArgumentException',
    'InvalidParameterException',
    'ResourceNotFoundException',
    'AccessDeniedException',
    'UnrecognizedClientException',
    'ExpiredTokenException',
    'InvalidSignatureException'
  ];
}
